// extracted by mini-css-extract-plugin
module.exports = {"cluster":"Cluster_cluster__AtHbW"};